import type {RouteLocationNormalizedLoaded} from 'vue-router'

export async function usePackageRuntimeData(route: RouteLocationNormalizedLoaded) {
    const {arrivalCityId, departureCityId} = route.query
    if (
        packagesRuntimeStore.arrivalPoint.id !== arrivalCityId ||
        packagesRuntimeStore.departurePoint.id !== departureCityId
    ) {
        await packagesRuntimeStore.loadPoints({arrivalCityId, departureCityId})
    }
}
